(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["authris-bf-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initializeBobChoices(scope) {
    const roots = [];
    if (scope.matches && scope.matches('[data-authris-bob-choices]')) roots.push(scope);
    scope.querySelectorAll('[data-authris-bob-choices]').forEach(root => roots.push(root));
    roots.forEach(root => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
      function selectTab(tab, focus) {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab, false));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) { event.preventDefault(); selectTab(next, true); }
        });
      });
      if (tabs[0]) selectTab(tabs[0], false);
      root.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[role="tabpanel"]');
        const tab = panel && tabs.find(item => item.getAttribute('aria-controls') === panel.id);
        if (tab) selectTab(tab, false);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeBobChoices(document));
  else initializeBobChoices(document);
  document.addEventListener('shopify:section:load', event => initializeBobChoices(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["authris-bf-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const money = value => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(value / 100);
  function activate(root, tab, focus = false) {
    root.querySelectorAll('[role="tab"]').forEach(item => {const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;});
    root.querySelectorAll('[role="tabpanel"]').forEach(panel => {panel.hidden=panel.id!==tab.getAttribute('aria-controls');});
    if(focus)tab.focus();
  }
  function initialize(scope) {
    const roots=[...(scope.matches?.('[data-bf-products]')?[scope]:[]),...scope.querySelectorAll('[data-bf-products]')];
    roots.forEach(root => {
      if(root.dataset.bfReady)return;root.dataset.bfReady='true';
      const tabs=[...root.querySelectorAll('[role="tab"]')];
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(root,tab));
        tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=tabs[(index+1)%tabs.length];if(event.key==='ArrowLeft')next=tabs[(index-1+tabs.length)%tabs.length];if(event.key==='Home')next=tabs[0];if(event.key==='End')next=tabs.at(-1);if(next){event.preventDefault();activate(root,next,true);}});
      });
      root.querySelectorAll('[data-bf-variant]').forEach(select=>select.addEventListener('change',()=>{
        const card=select.closest('[data-bf-card]'),option=select.selectedOptions[0];
        const sale=Number(option.dataset.sale),compare=Number(option.dataset.compare),discount=Math.round((1-sale/compare)*10000)/100;
        card.querySelector('[data-bf-sale]').textContent=money(sale);card.querySelector('[data-bf-compare]').textContent=money(compare);
        card.querySelector('[data-bf-save]').textContent=card.dataset.saveLabel+' '+discount+'%';
        card.querySelectorAll('[data-bf-product-link]').forEach(link=>{const url=new URL(link.href,location.origin);url.searchParams.set('variant',option.value);link.href=url.toString();});
      }));
      root.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[role="tabpanel"]');const tab=panel&&tabs.find(item=>item.getAttribute('aria-controls')===panel.id);if(tab)activate(root,tab);});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(document));else initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('click',event=>{const link=event.target.closest('[data-bf-open-tab]');if(!link)return;const tab=document.querySelector('[data-bf-tab-key="'+CSS.escape(link.dataset.bfOpenTab)+'"]');if(tab)activate(tab.closest('[data-bf-products]'),tab);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["authris-bob-choices"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initializeBobChoices(scope) {
    const roots = [];
    if (scope.matches && scope.matches('[data-authris-bob-choices]')) roots.push(scope);
    scope.querySelectorAll('[data-authris-bob-choices]').forEach(root => roots.push(root));
    roots.forEach(root => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
      function selectTab(tab, focus) {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab, false));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) { event.preventDefault(); selectTab(next, true); }
        });
      });
      if (tabs[0]) selectTab(tabs[0], false);
      root.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[role="tabpanel"]');
        const tab = panel && tabs.find(item => item.getAttribute('aria-controls') === panel.id);
        if (tab) selectTab(tab, false);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeBobChoices(document));
  else initializeBobChoices(document);
  document.addEventListener('shopify:section:load', event => initializeBobChoices(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
